import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import type { NurseTrainingStatus } from "../../utils/models";
import { trainingPayTarget } from "../../utils/wageRules/rateTypeTarget";
import { TRAINING_PAY_LINK_LABEL } from "./consts";
import { WageSettingsLink } from "./WageSettingsLink";
import type { WageComposition } from "./wageComposition";

/**
 * DAT-905's link beside the header's base, kept only where every priced row is shown as a rate type: no
 * training line exists there to say where a trainee's base came from. Once captured, the line itself is it.
 */
export const useLegacyTrainingLink = (
	composition: WageComposition | undefined,
	trainingStatus: NurseTrainingStatus | undefined,
	canOpenWageSettings: boolean,
): ReactNode => {
	const { t } = useTranslation();
	if (!composition || trainingStatus === undefined || !canOpenWageSettings) return undefined;
	const allRateTypeOnly = composition.segments.every((segment) => segment.type !== "paid" || segment.lines === null);
	const target = allRateTypeOnly ? trainingPayTarget(trainingStatus) : undefined;
	if (!target) return undefined;
	const label = t(TRAINING_PAY_LINK_LABEL[target.trainingStatus]);
	return (
		<WageSettingsLink
			target={target}
			label={label}
			ariaLabel={t("wageBreakdown.openInWageSettings", { rateType: label })}
			dataTestId="wage-breakdown-subtable-training-pay-link"
		/>
	);
};
